import { render, staticRenderFns } from "./MdfeMain.vue?vue&type=template&id=1b182aea"
import script from "./MdfeMain.vue?vue&type=script&lang=js"
export * from "./MdfeMain.vue?vue&type=script&lang=js"
import style0 from "./MdfeMain.vue?vue&type=style&index=0&id=1b182aea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports